export const CONSTANTS = {
  API_URL: process.env.REACT_APP_API_URL,
  DEBUG: process.env.REACT_APP_DEBUG,
};
